import { useGetCountryCodeOptions } from 'hooks/useGetCountryCodeOptions';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Box, TextField, Typography } from '@mui/material';

import { Select } from 'components/shared';
import {
  GridContainer,
  GridCompact3,
  GridCompact4,
  GridCompact6,
  GridCompact8
} from 'components/shared/Grid/Grid.components';

type Props = {
  formKey: string;
};

const AddressForm = ({ formKey }: Props) => {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const options = useGetCountryCodeOptions();

  return (
    <Box mt={3}>
      <Typography variant="h6" sx={{ mb: 1 }}>
        {t(`travelDistances.${formKey}`)}
      </Typography>
      <GridContainer>
        <GridCompact8>
          <Controller
            name={`${formKey}.street`}
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                fullWidth
                label={t('street')}
                error={!!fieldState.error}
                helperText={fieldState.error?.message ?? null}
                required
              />
            )}
          />
        </GridCompact8>
        <GridCompact4>
          <Controller
            name={`${formKey}.houseNumber`}
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                fullWidth
                label={t('houseNumber')}
                error={!!fieldState.error}
                helperText={fieldState.error?.message ?? null}
                required
              />
            )}
          />
        </GridCompact4>
        <GridCompact3>
          <Controller
            name={`${formKey}.postalCode`}
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                fullWidth
                label={t('postalCode')}
                error={!!fieldState.error}
                helperText={fieldState.error?.message ?? null}
                required
              />
            )}
          />
        </GridCompact3>
        <GridCompact6>
          <Controller
            name={`${formKey}.city`}
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                fullWidth
                label={t('city')}
                error={!!fieldState.error}
                helperText={fieldState.error?.message ?? null}
                required
              />
            )}
          />
        </GridCompact6>
        <GridCompact4>
          <Controller
            name={`${formKey}.countryCode`}
            control={control}
            render={({ field, fieldState }) => (
              <Select
                fullWidth
                {...field}
                onSelected={field.onChange}
                label={t('country')}
                options={options}
                error={fieldState.error}
                valueProp={field.value}
                required
              />
            )}
          />
        </GridCompact4>
      </GridContainer>
    </Box>
  );
};

export default AddressForm;
